/* Ürün sayfası: galeri thumbnail değişimi + adet sayacı */
(function () {
  'use strict';

  const pStrings = window.productStrings || {};

  // Galeri: thumbnail + görsel indeks yönetimi
  const main = document.getElementById('ProductMainImage');
  const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
  const gallery = thumbs.length
    ? thumbs.map((t) => t.getAttribute('data-thumb'))
    : (main ? [main.currentSrc || main.src] : []);
  let galleryIndex = 0;

  function setMainImage(index) {
    if (!main || !gallery.length) return;
    galleryIndex = (index + gallery.length) % gallery.length;
    main.src = gallery[galleryIndex];
    main.removeAttribute('srcset');
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === galleryIndex));
  }
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => setMainImage(i)));

  // Mobil kaydırma (swipe) ile görsel değiştir
  if (main && gallery.length > 1) {
    let startX = 0, startY = 0;
    main.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) setMainImage(galleryIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* ----- Lightbox (görsel büyüteç) ----- */
  let lightbox = null, lbImg = null, lbIndex = 0, lastFocus = null;
  function buildLightbox() {
    if (lightbox) return;
    lightbox = document.createElement('div');
    lightbox.className = 'pdp-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.hidden = true;
    const multi = gallery.length > 1;
    lightbox.innerHTML =
      '<button type="button" class="pdp-lightbox__close" data-lb-close aria-label="' + (pStrings.zoom_close || 'Kapat') + '">&times;</button>' +
      (multi ? '<button type="button" class="pdp-lightbox__nav pdp-lightbox__nav--prev" data-lb-prev aria-label="' + (pStrings.zoom_prev || 'Önceki') + '">&#8249;</button>' : '') +
      '<div class="pdp-lightbox__figure"><img class="pdp-lightbox__img" alt="" src=""></div>' +
      (multi ? '<button type="button" class="pdp-lightbox__nav pdp-lightbox__nav--next" data-lb-next aria-label="' + (pStrings.zoom_next || 'Sonraki') + '">&#8250;</button>' : '');
    document.body.appendChild(lightbox);
    lbImg = lightbox.querySelector('.pdp-lightbox__img');
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target.closest('[data-lb-close]')) closeLightbox();
      else if (e.target.closest('[data-lb-prev]')) showLb(lbIndex - 1);
      else if (e.target.closest('[data-lb-next]')) showLb(lbIndex + 1);
    });
  }
  function showLb(index) {
    if (!gallery.length) return;
    lbIndex = (index + gallery.length) % gallery.length;
    lbImg.src = gallery[lbIndex];
  }
  function openLightbox(index) {
    buildLightbox();
    lastFocus = document.activeElement;
    showLb(index);
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    lightbox.querySelector('[data-lb-close]').focus();
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', (e) => {
    if (!lightbox || lightbox.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowLeft' && gallery.length > 1) showLb(lbIndex - 1);
    else if (e.key === 'ArrowRight' && gallery.length > 1) showLb(lbIndex + 1);
  });
  document.querySelector('[data-zoom-open]')?.addEventListener('click', () => openLightbox(galleryIndex));
  main?.addEventListener('click', () => openLightbox(galleryIndex));

  // Adet sayacı (stok üst sınırına saygılı)
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    const getMax = () => {
      const m = parseInt(input.getAttribute('max'), 10);
      return Number.isFinite(m) && m > 0 ? m : Infinity;
    };
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = Math.min(getMax(), (parseInt(input.value, 10) || 1) + 1);
    });
    input.addEventListener('change', () => {
      let v = parseInt(input.value, 10) || 1;
      v = Math.max(1, Math.min(getMax(), v));
      input.value = v;
    });
  });

  /* ----- Sosyal paylaşım: linki kopyala ----- */
  document.querySelector('[data-share-copy]')?.addEventListener('click', async (e) => {
    const btn = e.currentTarget;
    const url = btn.getAttribute('data-share-url') || window.location.href;
    try { await navigator.clipboard.writeText(url); } catch (_) {}
    btn.classList.add('is-copied');
    if (window.Theme && window.Theme.toast) window.Theme.toast(pStrings.share_copied || 'Bağlantı kopyalandı');
    setTimeout(() => btn.classList.remove('is-copied'), 1500);
  });

  /* ----- Varyant seçici ----- */
  const strings = window.productStrings || {};
  const money = (cents) => (window.Theme && window.Theme.money) ? window.Theme.money(cents) : ((cents || 0) / 100).toFixed(2) + ' ₺';
  const CHECK_SVG = '<svg class="icon icon--check" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l4 4 10-10" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const selector = document.querySelector('[data-variant-selector]');
  if (selector) {
    let variants = [];
    try { variants = JSON.parse(selector.querySelector('[data-variant-json]').textContent); } catch (e) { variants = []; }

    const selectedOptions = () => {
      const opts = [];
      selector.querySelectorAll('.product__option').forEach((fs) => {
        const checked = fs.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    };
    const findVariant = (opts) => variants.find((v) => opts.every((val, i) => v.options[i] === val));

    const updateSelectedLabels = () => {
      selector.querySelectorAll('.product__option').forEach((fs) => {
        const checked = fs.querySelector('input:checked');
        const span = fs.querySelector('[data-option-selected]');
        if (checked && span) span.textContent = checked.value;
      });
    };
    const updatePrice = (v) => {
      const block = document.querySelector('[data-price-block] .price');
      if (!block) return;
      const cur = block.querySelector('.price__current');
      if (cur) cur.textContent = money(v.price);
      let cmp = block.querySelector('.price__compare');
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      block.classList.toggle('price--on-sale', !!onSale);
      if (onSale) {
        if (!cmp) { cmp = document.createElement('span'); cmp.className = 'price__compare'; block.insertBefore(cmp, cur); }
        cmp.textContent = money(v.compare_at_price);
      } else if (cmp) { cmp.remove(); }
      const scur = document.querySelector('.product-sticky__price .price__current');
      if (scur) scur.textContent = money(v.price);
      // Havale/EFT kutusu — tutar her zaman guncel varyant fiyatindan hesaplanir
      const eftBox = document.querySelector('[data-eft-box]');
      if (eftBox) {
        const pct = parseFloat(eftBox.dataset.eftPct) || 0;
        const amt = eftBox.querySelector('[data-eft-amount]');
        if (amt && pct > 0 && pct < 100) {
          amt.textContent = money(Math.round(v.price * (100 - pct) / 100));
        }
        eftBox.hidden = !(v.price > 0);
      }
    };
    const updateAvailability = (v) => {
      const available = !!(v && v.available);
      document.querySelectorAll('[data-add-button]').forEach((btn) => { btn.disabled = !available; });
      const label = document.querySelector('[data-add-label]');
      if (label) label.textContent = available ? (strings.add_to_cart || label.textContent) : (strings.sold_out || 'Tükendi');
      const stock = document.querySelector('[data-stock-target]');
      if (stock) {
        stock.innerHTML = available
          ? ''
          : '<span class="stock stock--out">' + (strings.out_of_stock || 'Stokta Yok') + '</span>';
      }
      const low = document.querySelector('[data-lowstock]');
      if (low) low.hidden = true; // kesin adet varyanta özel değil, değişimde gizle
    };
    const updateImage = (v) => {
      if (!v || !v.featured_image || !v.featured_image.src) return;
      if (main) { main.src = v.featured_image.src; main.removeAttribute('srcset'); }
    };
    const updateSku = (v) => {
      document.querySelectorAll('[data-variant-sku]').forEach((el) => {
        if (v.sku) { el.textContent = v.sku; el.closest('[data-sku-row]') && (el.closest('[data-sku-row]').hidden = false); }
      });
      const copyBtn = document.querySelector('[data-copy-sku]');
      if (copyBtn && v.sku) copyBtn.setAttribute('data-copy', v.sku);
    };
    const updateQtyMax = (v) => {
      const tracked = v.inventory_management && v.inventory_management !== '' && v.inventory_policy !== 'continue';
      document.querySelectorAll('[data-qty-input]').forEach((inp) => {
        if (tracked && Number.isFinite(v.inventory_quantity) && v.inventory_quantity > 0) {
          inp.setAttribute('max', v.inventory_quantity);
          if ((parseInt(inp.value, 10) || 1) > v.inventory_quantity) inp.value = v.inventory_quantity;
        } else {
          inp.removeAttribute('max');
        }
      });
    };
    const updateIds = (v) => {
      document.querySelectorAll('[data-variant-id]').forEach((inp) => { inp.value = v.id; });
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    };
    // Tükenmiş varyant değerlerini işaretle: seçili diğer seçeneklerle o değer stokta mı?
    const markOptionAvailability = () => {
      const current = selectedOptions();
      selector.querySelectorAll('.product__option').forEach((fs, optIndex) => {
        fs.querySelectorAll('.product__option-input').forEach((input) => {
          const candidate = current.slice();
          candidate[optIndex] = input.value;
          const match = variants.find((vr) => candidate.every((val, i) => vr.options[i] === val));
          const unavailable = !match || !match.available;
          const label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('product__option-btn--soldout', unavailable);
        });
      });
    };

    selector.addEventListener('change', (e) => {
      if (!e.target.classList.contains('product__option-input')) return;
      updateSelectedLabels();
      const v = findVariant(selectedOptions());
      if (!v) {
        document.querySelectorAll('[data-add-button]').forEach((b) => { b.disabled = true; });
        const label = document.querySelector('[data-add-label]');
        if (label) label.textContent = strings.unavailable || 'Mevcut değil';
        markOptionAvailability();
        return;
      }
      updateIds(v);
      updatePrice(v);
      updateAvailability(v);
      updateImage(v);
      updateSku(v);
      updateQtyMax(v);
      markOptionAvailability();
    });
    markOptionAvailability();
  }

  /* ----- OEM / stok kodu kopyalama ----- */
  document.querySelectorAll('[data-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const text = btn.getAttribute('data-copy');
      try {
        await navigator.clipboard.writeText(text);
      } catch (e) {
        const ta = document.createElement('textarea');
        ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (_) {}
        ta.remove();
      }
      btn.classList.add('is-copied');
      const original = btn.getAttribute('aria-label');
      if (strings.copied) btn.setAttribute('aria-label', strings.copied);
      setTimeout(() => {
        btn.classList.remove('is-copied');
        if (original) btn.setAttribute('aria-label', original);
      }, 1500);
    });
  });

  // Mobil sticky sepete-ekle çubuğu: ana buton görünüm dışına çıkınca göster
  const sticky = document.querySelector('[data-product-sticky]');
  const mainBuy = document.querySelector('.product__buy');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    const show = (on) => {
      sticky.hidden = !on;
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sticky.classList.toggle('is-visible', on);
    };
    const observer = new IntersectionObserver(
      (entries) => { show(!entries[0].isIntersecting); },
      { rootMargin: '0px 0px -40% 0px' }
    );
    observer.observe(mainBuy);
  }
})();
